'use strict';

var _classCallCheck = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var common = require('./common.js');

var token = require('./token.js');

var jump = require('./jump.js');

var defaultDecodeOptions = {
  strict: false,
  allowIndefinite: true,
  allowUndefined: true,
  allowBigInt: true
};

var Tokeniser = /*#__PURE__*/function () {
  function Tokeniser(data) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Tokeniser);

    this.pos = 0;
    this.data = data;
    this.options = options;
  }

  _createClass(Tokeniser, [{
    key: "done",
    value: function done() {
      return this.pos >= this.data.length;
    }
  }, {
    key: "next",
    value: function next() {
      var byt = this.data[this.pos];
      var token = jump.quick[byt];

      if (token === undefined) {
        var decoder = jump.jump[byt];

        if (!decoder) {
          throw new Error("".concat(common.decodeErrPrefix, " no decoder for major type ").concat(byt >>> 5, " (byte 0x").concat(byt.toString(16).padStart(2, '0'), ")"));
        }

        var minor = byt & 31;
        token = decoder(this.data, this.pos, minor, this.options);
      }

      this.pos += token.encodedLength;
      return token;
    }
  }]);

  return Tokeniser;
}();

var DONE = Symbol.for('DONE');
var BREAK = Symbol.for('BREAK');

function tokenToArray(token, tokeniser, options) {
  var arr = [];

  for (var i = 0; i < token.value; i++) {
    var value = tokensToObject(tokeniser, options);

    if (value === BREAK) {
      if (token.value === Infinity) {
        break;
      }

      throw new Error("".concat(common.decodeErrPrefix, " got unexpected break to lengthed array"));
    }

    if (value === DONE) {
      throw new Error("".concat(common.decodeErrPrefix, " found array but not enough entries (got ").concat(i, ", expected ").concat(token.value, ")"));
    }

    arr[i] = value;
  }

  return arr;
}

function tokenToMap(token, tokeniser, options) {
  var useMaps = options.useMaps === true;
  var obj = useMaps ? undefined : {};
  var m = useMaps ? new Map() : undefined;

  for (var i = 0; i < token.value; i++) {
    var key = tokensToObject(tokeniser, options);

    if (key === BREAK) {
      if (token.value === Infinity) {
        break;
      }

      throw new Error("".concat(common.decodeErrPrefix, " got unexpected break to lengthed map"));
    }

    if (key === DONE) {
      throw new Error("".concat(common.decodeErrPrefix, " found map but not enough entries (got ").concat(i, " [no key], expected ").concat(token.value, ")"));
    }

    if (useMaps !== true && typeof key !== 'string') {
      throw new Error("".concat(common.decodeErrPrefix, " non-string keys not supported (got ").concat(typeof key, ")"));
    }

    var value = tokensToObject(tokeniser, options);

    if (value === DONE) {
      throw new Error("".concat(common.decodeErrPrefix, " found map but not enough entries (got ").concat(i, " [no value], expected ").concat(token.value, ")"));
    }

    if (useMaps) {
      m.set(key, value);
    } else {
      obj[key] = value;
    }
  }

  return useMaps ? m : obj;
}

function tokensToObject(tokeniser, options) {
  if (tokeniser.done()) {
    return DONE;
  }

  var token$1 = tokeniser.next();

  if (token$1.type === token.Type.break) {
    return BREAK;
  }

  if (token$1.type.terminal) {
    return token$1.value;
  }

  if (token$1.type === token.Type.array) {
    return tokenToArray(token$1, tokeniser, options);
  }

  if (token$1.type === token.Type.map) {
    return tokenToMap(token$1, tokeniser, options);
  }

  if (token$1.type === token.Type.tag) {
    if (options.tags && typeof options.tags[token$1.value] === 'function') {
      var tagged = tokensToObject(tokeniser, options);
      return options.tags[token$1.value](tagged);
    }

    throw new Error("".concat(common.decodeErrPrefix, " tag not supported (").concat(token$1.value, ")"));
  }

  throw new Error('unsupported');
}

function decode(data, options) {
  if (!(data instanceof Uint8Array)) {
    throw new Error("".concat(common.decodeErrPrefix, " data to decode must be a Uint8Array"));
  }

  options = Object.assign({}, defaultDecodeOptions, options);
  var tokeniser = options.tokenizer || new Tokeniser(data, options);
  var decoded = tokensToObject(tokeniser, options);

  if (decoded === DONE) {
    throw new Error("".concat(common.decodeErrPrefix, " did not find any content to decode"));
  }

  if (decoded === BREAK) {
    throw new Error("".concat(common.decodeErrPrefix, " got unexpected break"));
  }

  if (!tokeniser.done()) {
    throw new Error("".concat(common.decodeErrPrefix, " too many terminals, data makes no sense"));
  }

  return decoded;
}

exports.Tokeniser = Tokeniser;
exports.decode = decode;
exports.tokensToObject = tokensToObject;